import { client } from '../../client';
import { LessonFragment, LessonsDocument, LessonsQuery, LessonsQueryVariables } from '../types';

// [] Get all lessons
export async function getLessons(variables: LessonsQueryVariables): Promise<LessonFragment[]> {
  try {
    const result = await client.query<LessonsQuery, LessonsQueryVariables>({
      query: LessonsDocument,
      variables,
    });
    return result.data.lessons;
  } catch (error) {
    throw Error(error);
  }
}
